import { render, staticRenderFns } from "./ChangePasswordButton.vue?vue&type=template&id=107d9a94"
import script from "./ChangePasswordButton.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports